<div class="-api-overview-wrapper">
  <div class="-overview-page-content">
    <div class="-left-pane" [ngClass]="!hasContact && !isDocIndex ? '-full-width' : '-pane-width'">
      @if (body) {
      <content-viewer [content]="body" (docRendered)="handleDocRendered($event)"></content-viewer>
      }
    </div>
    @if (hasContact || isDocIndex) {
    <div class="-right-pane">
      <div class="sticky-right-pane">
        @if (isDocIndex && docIndexReady) {
        <app-doc-index [indexContainer]="'content-viewer'" [title]="'Within this Page'"></app-doc-index>
        } @if (hasContact) {
        <contact-block-banner class="contact-block -desktop"></contact-block-banner>
        }
      </div>
    </div>
    }
  </div>
</div>
